import { useDisciplineHelper } from "@composables/masterdata/competitions/disciplines";
import AppDisciplinesCard from "./AppDisciplinesCard.vue";
export default {
  name: "AppDisciplinesCardTemplate",
  props: {
    params: {
      type: Object,
      default: () => {}
    }
  },
  setup() {
    return {
      ...useDisciplineHelper()
    };
  },
  render(h) {
    return h(AppDisciplinesCard, {
      props: {
        params: this.params,
        disciplines: this.disciplinesTranslated
      },
      scopedSlots: this.$scopedSlots
    });
  }
};
